import {
  ColumnMeta,
  FilterResultMethod,
  FilterResults,
} from '@api/api/screener';
import { InfiniteData } from '@tanstack/react-query';

interface Results {
  category: string;
  key: string;
  data: FilterResultMethod[];
  meta: ColumnMeta[];
}

export const extractScreenerKGData = (results?: Results[]) => {
  const kgData = results?.find(d => d.key === 'knowledge_graph');

  return {
    data: kgData?.data ?? [],
    meta: kgData?.meta ?? [],
  };
};

export const extractPerfKGData = (results?: Results[]) => {
  const kgData = results?.find(d => d.key === 'performance');

  return {
    data: kgData?.data ?? [],
    meta: kgData?.meta ?? [],
  };
};

export const extractScreenerOverviewData = (results?: Results[]) => {
  const kgData = results?.find(d => d.key === 'overview');

  return {
    data: kgData?.data ?? [],
    meta: kgData?.meta ?? [],
  };
};

export const combineScreenerPagesData = (
  screenerData?: InfiniteData<FilterResults>
) => {
  return screenerData?.pages?.flatMap(page => {
    const screenerKGData = extractScreenerKGData(page?.data).data;
    const screenerPerfData = extractPerfKGData(page?.data).data;

    const combinedData = screenerKGData.map((kgItem, idx) => {
      const perfData = screenerPerfData?.[idx] ?? {};

      return {
        ...perfData,
        ...kgItem,
      };
    });

    return combinedData;
  });
};
